import { AuthLoginButton } from "./AuthLoginButton";
import { AuthLogoutButton } from "./AuthLogoutButton";

export const AuthLogin = (props: any) => {
  const email: string | undefined = props.email;
  const appName: string = props.appName;
  const sx: any = props.sx;
  return (
    <>
      {email ? (
        <AuthLogoutButton appName={appName} sx={sx} />
      ) : (
        <AuthLoginButton name="Sign in" appName={appName} sx={sx} />
      )}
    </>
  );
};
